export default __webpack_public_path__ + "static/media/icon-coin-op.98e0a2ff.svg";